import { Crown } from 'lucide-react';

interface Props { number: number | null; }

export default function FoundingBadge({ number }: Props) {
  if (number == null) return null;
  return (
    <div className="inline-flex items-center gap-2 rounded-full bg-accent-alt/15 px-3 py-1.5">
      <Crown className="w-3.5 h-3.5 text-gold-ink" />
      <span className="font-heading text-[8px] text-gold-ink">FOUNDING · #{String(number).padStart(2, '0')} OF 10</span>
    </div>
  );
}
